<template>
    <div class="overflow-x-auto mt-sm">
        <table class="table condensed striped">
            <tbody>
                <tr v-for="(label, columnName) in columns">
                    <td class="w-2/5">{{ label }}</td>
                    <td>{{ address[columnName] || '-' }}</td>
                    <td
                        v-if="canEdit"
                        class="flex justify-end"
                    >
                        <button
                            class="btn-icon"
                            @click="selectItem(columnName, label)"
                        >
                            <font-awesome-icon icon="pencil" size="sm" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <adaptive-form-modal
            v-if="canEdit"
            :name="`edit-operation-item`"
            :title="`Redigera ${selectedColumnLabel}`"
            method="patch"
            :action="route('api.delivery-projects.addresses.operation-item.update', address.id)"
            :redirect-to="redirectTo"
        >
            <text-input
                type="hidden"
                :value="selectedColumnName"
                name="column"
            />
            <text-input
                v-model="selectedColumnValue"
                :required="true"
                :autofocus="true"
                name="value"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            columns: {
                type: Object,
                required: true,
            },
            canEdit: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                selectedColumnName: null,
                selectedColumnLabel: null,
                selectedColumnValue: null,
            };
        },
        computed: {
            redirectTo() {
                return window.location.href;
            },
        },
        methods: {
            selectItem(columnName, label) {
                this.selectedColumnName = columnName;
                this.selectedColumnLabel = label;
                this.selectedColumnValue = this.address[columnName];

                this.$modal.show('edit-operation-item');
            },
        },
    };
</script>
